import { Column, RowData } from '@tanstack/react-table';
import { AppTableFeatures } from '~/components/table/appTableFeatures';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import React from 'react';
import { SkeletonElement } from './SkeletonElement';

type TableRowSkeletonLoaderProps<TData extends RowData = RowData> = {
  columns: Column<AppTableFeatures, TData, unknown>[];
  rowHeight: number;
};

export const TableRowSkeletonLoader = <TData extends RowData>({
  columns,
  rowHeight,
}: TableRowSkeletonLoaderProps<TData>) => {
  return (
    <motion.tr
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className={classNames(
        'border-b border-gray-200 dark:border-gray-700',
        'h-[inherit]'
      )}
      style={{
        height: `${rowHeight}px`,
      }}
    >
      {columns.map((column) => (
        <td
          key={column.id}
          style={{
            width: column.getSize(),
          }}
          className={classNames(
            'px-4 py-2 align-middle',
            column.columnDef.meta?.align === 'right'
              ? 'text-right'
              : 'text-left'
          )}
        >
          <SkeletonElement />
        </td>
      ))}
    </motion.tr>
  );
};
